import React from 'react';
import { useSelector } from 'react-redux';

import { PostLikesLayout } from '../../components/PostLikesLayout';
import { PostLikes, PostLikesSkeleton } from '../../components/PostLikes';
import { PostTelegramLink, PostTelegramLinkSkeleton } from '../../components/PostTelegramLink';
import { useLikes } from './utils';
import { getLinkData } from '../../utils';
import { selectPost } from '../../selectors/post';
import { selectUser } from '../../selectors/user';
import { PERMISSIONS } from '../../../app/permissions/permissionsNew';
import { ERequestStatus } from '../../types/requestStatus';
import { ELikeType } from '../../types/likes';
import { EType } from '../../repositories/journal/entities/journal/JournalAttributesSchema';

/**
 * Контейнер блока лайков для поста
 */
export const PostLikesContainer = () => {
  const post = useSelector(selectPost);
  const user = useSelector(selectUser);
  const { handleLikeClick, isLikesLoading } = useLikes();

  if (ERequestStatus.Loading === post.status) {
    return (
      <PostLikesLayout>
        <PostLikesSkeleton />
        <PostTelegramLinkSkeleton />
      </PostLikesLayout>
    );
  }

  if (!('id' in post)) {
    return null;
  }

  const {
    id: postId,
    attributes: { type: postType, userLikeValue, telegramChannel, tags },
  } = post;
  const permissions = PERMISSIONS[postType];
  const isUserLiked = Boolean(userLikeValue);
  const telegramLinkData = getLinkData({
    tags,
    telegramChannel: telegramChannel ?? undefined,
    isB2BModeEnabled: user.isB2BModeEnabled,
  });
  const isPostLikesShown = postType === EType.Articles && !isUserLiked;
  const isTelegramLinkShown = ![EType.Blogs, EType.Questions].includes(postType);

  if (!isPostLikesShown && !isTelegramLinkShown) {
    return null;
  }

  return (
    <PostLikesLayout>
      {isPostLikesShown && (
        <PostLikes
          isDisabled={isLikesLoading || !permissions.canLikes(user, post)}
          onLikeClick={() => handleLikeClick({ postId, postType, likeType: ELikeType.Like })}
          onDislikeClick={() => handleLikeClick({ postId, postType, likeType: ELikeType.Dislike })}
        />
      )}

      {isTelegramLinkShown && <PostTelegramLink {...telegramLinkData} />}
    </PostLikesLayout>
  );
};
